import NavItem from "@/domain/entities/navbar/NavItem";
import { customViewRootUrl } from "@/router/routes";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import CustomViewItem from "./CustomViewItem";

type CustomViewsListProps = {
    customviewsNavItems: NavItem[];
};

const CustomViewsList = ({ customviewsNavItems }: CustomViewsListProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <div>
            <Button
                className="mt-2 w-full rounded-lg p-2 hover:bg-surface-primary [&_div]:w-full [&_div]:justify-between"
                onClick={() => setIsOpen(!isOpen)}
                variant="ghost"
            >
                <p className="text-xs text-text-caption">
                    {t("navbar.customViews.seeMore")}
                </p>
                {isOpen ? (
                    <ChevronUp className="h-4 w-4 text-text-caption" />
                ) : (
                    <ChevronDown className="h-4 w-4 text-text-caption" />
                )}
            </Button>
            {isOpen && (
                <ul className="flex flex-col gap-1">
                    {customviewsNavItems.map((view) => (
                        <CustomViewItem
                            key={view.id}
                            icon={view.menuInfo?.icon}
                            label={view.menuInfo?.title}
                            to={`/${customViewRootUrl}/${view.id}`}
                        />
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomViewsList;
